import { render, staticRenderFns } from "./navTabAlbum.vue?vue&type=template&id=48585128&scoped=true"
import script from "./navTabAlbum.vue?vue&type=script&lang=js"
export * from "./navTabAlbum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48585128",
  null
  
)

export default component.exports